var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.openModal)?_c('v-container',{attrs:{"fluid":""}},[_c('v-fade-transition',[_c('v-overlay',{attrs:{"opacity":_vm.$attrs.opacity || 0.7,"absolute":"","z-index":"5","color":"accent"}},[_vm._t("default")],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }